import { RouteRecordRaw } from "vue-router";
import List from "@/views/playground/player/partner/r2center/List.vue";
import About from "@/views/playground/player/partner/r2center/About.vue";
import Review from "@/views/playground/player/partner/r2center/Review.vue";
import Service from "@/views/playground/player/partner/r2center/Service.vue";
import MyR2Center from "@/views/playground/player/partner/r2center/MyR2Center.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    redirect: (to) => `/playground/player/partner/r2center/list`,
  },
  {
    path: "list",
    component: List,
  },
  {
    path: ":partnerId/about",
    component: About,
  },
  {
    path: ":partnerId/review",
    component: Review,
  },
  {
    path: ":partnerId/service",
    component: Service,
  },
  {
    path: ":partnerId/my",
    component: MyR2Center,
  },
];

export default routes;
